import { render, staticRenderFns } from "./Goals.vue?vue&type=template&id=394feed0&scoped=true&"
import script from "./Goals.vue?vue&type=script&lang=js&"
export * from "./Goals.vue?vue&type=script&lang=js&"
import style0 from "./Goals.vue?vue&type=style&index=0&id=394feed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394feed0",
  null
  
)

export default component.exports